const LOASourceEnum = Object.freeze({
    UPLOADED: 'UPLOADED',
    GENERATED: 'GENERATED'
});

export default LOASourceEnum;
